import { render } from "./appMain.vue?vue&type=template&id=19ad17ae&scoped=true&ts=true"
import script from "./appMain.vue?vue&type=script&lang=ts"
export * from "./appMain.vue?vue&type=script&lang=ts"

import "./appMain.vue?vue&type=style&index=0&id=19ad17ae&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjft-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ad17ae"]])

export default __exports__